import { HandlerRegistry } from "@/services/IframeBridge/messagesTypes.ts";
import { CommonInboundAction } from "./actions.ts";
import { useAuth } from "@/composables/useAuth";
import { SessionHub } from '@/utils/sessionHub';

export const CommonRegistry: HandlerRegistry<CommonInboundAction> = {
    UNAUTHORIZED_ACCESS: async (payload) => {
        const { logout } = useAuth();

        await logout(payload.redir || null, payload.errorMsg || null);
    },
    IFRAME_USER_ACTIVITY: () => {
        SessionHub.triggerActivityPulse();
    }
};